import { getTokens } from 'core/classes/helpers/StorageHelper'
import WebSocketStore from 'core/classes/services/WebSocketStore'

interface IInitPlan {
  ownerId: string
  partnerId: string
  fYear: number
}

export const initPlan = async ({ ownerId, fYear, partnerId }: IInitPlan) => {
  const wsClient = WebSocketStore.get('partner360')
  const [token] = getTokens(ownerId)

  try {
    const res = await wsClient.call({
      service: 'partnerPlan',
      action: 'initPlan',
      payload: { fYear, partnerId },
      token: token || undefined,
      withoutTokenRefresh: true,
      isAuth: true,
    })
    return res.data
  } catch (e: any) {
    return null
  }
}
